
let createPostContacto =
  ({ fetch, environment, buildRequestWithAuth, errorUnlessOk, parseError }) =>
  (solicitudId, data) => {
    let request = buildRequestWithAuth("POST", data);

    return fetch(
      `${environment.originacionUrl}/solicitudes/${solicitudId}/contacto`,
      request
    )
      .then(errorUnlessOk)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        let resultError = parseError(error, "createPostContacto");
        console.error(resultError);
        throw resultError;
      });
  };

let createPostContactoConsumo =
  ({ fetch, environment, buildRequestWithAuth, errorUnlessOk, parseError }) =>
  (data) => {
    let request = buildRequestWithAuth("POST", data);

    return fetch(
      `${environment.originacionUrl}/consumo/solicitudes/${data.Id}/telefonoContacto`,
      request
    )
      .then(errorUnlessOk)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        let resultError = parseError(error, "createPostContactoConsumo");
        console.error(resultError);
        throw resultError;
      });
  };

let createPostEmailConsumo =
  ({ fetch, environment, buildRequestWithAuth, errorUnlessOk, parseError }) =>
  (data) => {
    let request = buildRequestWithAuth("POST", data);

    return fetch(
      `${environment.originacionUrl}/consumo/solicitudes/${data.Id}/emailContacto`,
      request
    )
      .then(errorUnlessOk)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        let resultError = parseError(error, "createPostEmailConsumo");
        console.error(resultError);
        throw resultError;
      });
  };

let createDeleteTelefono =
  ({ fetch, environment, buildRequestWithAuth, errorUnlessOk, parseError }) =>
  (solicitudId, numero) => {
    let request = buildRequestWithAuth("DELETE", {
      Id: solicitudId,
      Numero: numero,
    });

    return fetch(
      `${environment.originacionUrl}/solicitudes/${solicitudId}/contacto/telefono`,
      request
    )
      .then(errorUnlessOk)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        let resultError = parseError(error, "createDeleteTelefono");
        console.error(resultError);
        throw resultError;
      });
  };

export {
  createPostContacto,
  createDeleteTelefono,
  createPostContactoConsumo,
  createPostEmailConsumo,
};
